import { t } from "@lingui/core/macro";
import { Store } from "lucide-react";

/**
 * Marks an appointment a customer booked through the marketplace platform, as
 * opposed to the client's own online booking form. Intended to sit inline next
 * to the customer's name on calendar appointment blocks.
 *
 * Labelled with a native `title` rather than a HeroUI `Tooltip` because every
 * render site already sits inside the appointment block's hover tooltip.
 */
export const MarketplaceBookingIndicator = ({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  const label = t`Naročeno preko platforme`;

  return (
    <span
      className={`text-primary inline-flex shrink-0 items-center ${className ?? ""}`}
      title={label}
      aria-label={label}
      data-identifier="marketplace-booking-indicator"
    >
      <Store size={size} aria-hidden />
    </span>
  );
};
